export default {
  categories: [],
  blogs: [],
};
